// really wish I could make ts work for this but I have better things to do

export const lengthEnum = {
  short: 0,
  medium: 1,
  long: 2
};
